export const ApiLetterheads = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const create = async (formData) => {
    axios.setHeader('Content-Type', 'multipart/form-data')
    const result = await axios.$post('/api/settings/letterheads', formData)
    return result
  }

  const find = async (id) => {
    const result = await axios.get(`/api/settings/letterheads/${id}`)
    return result.data
  }

  const load = async () => {
    const result = await axios.get('/api/settings/letterheads')
    return result.data
  }

  const save = async (id, payload) => {
    const result = await axios.post(`/api/settings/letterheads/${id}`, payload)
    return result.data
  }

  const trash = async (id, payload) => {
    const result = await axios.delete(`/api/settings/letterheads/${id}`)
    return result.data
  }

  return {
    letterheadsCreate: create,
    letterheadsDelete: trash,
    letterheadsFind: find,
    letterheadsLoad: load,
    letterheadsSave: save
  }
}
